module.exports = __webpack_public_path__ + "img/Res_Mus_dkl.31d78701.jpg";